import React, {useState} from "react";
import Form from "./Form"
import {useMovementData} from "../../hooks/useMovementData";
import {useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useMovementsRateData} from "../../hooks/useMovementsRateData";
import {useMovementTypesData} from "../../hooks/useMovementTypesData";
import {useDriversData} from "../../hooks/useDriversData";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";

export default function MovementForm(props){
    let dataFresh = useSelector(getDataFresh);


    let loaded = useMovementData(props.match.params.movement, dataFresh);
    let departmentsLoaded = useDepartmentsData({});
    let movementTypesLoaded = useMovementTypesData({page_size:1000});
    let driversLoaded = useDriversData({page_size:1000});
    let trackingOptionsLoaded = useTrackingOptionsData({page_size: 1000});

    return (
        <Form
            loaded={loaded && departmentsLoaded && movementTypesLoaded && driversLoaded && trackingOptionsLoaded}
            dataFresh={dataFresh}
            endpoint={props.endpoint}
        />
    )

}